import { render } from "./ManageGroupAssignment.vue?vue&type=template&id=77f935c4&lang=pug"
import script from "./ManageGroupAssignment.vue?vue&type=script&lang=js"
export * from "./ManageGroupAssignment.vue?vue&type=script&lang=js"

import "./ManageGroupAssignment.vue?vue&type=style&index=0&id=77f935c4&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__